import { render, staticRenderFns } from "./ren-task-handle.vue?vue&type=template&id=7997c868"
import script from "./ren-task-handle.vue?vue&type=script&lang=js"
export * from "./ren-task-handle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports